"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardListener = void 0;
const react_1 = require("react");
const KEY_CODE_ESCAPE = 27;
function useKeyboardListener(callback, keyCode) {
    keyCode = keyCode !== null && keyCode !== void 0 ? keyCode : KEY_CODE_ESCAPE;
    react_1.useEffect(() => {
        const keyboardListener = event => {
            if (event.keyCode === keyCode) {
                event.stopPropagation();
                callback();
            }
        };
        document.addEventListener('keydown', keyboardListener);
        return () => document.removeEventListener('keydown', keyboardListener);
    }, [callback]);
}
exports.useKeyboardListener = useKeyboardListener;
